"use strict";

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (fpConfigurator) {
  fpConfigurator.registerTab("documentsTree", {
    label: "fiche.Documents",
    icon: "fa-list-alt",
    fragment: "documentsTree",
    controller: "InventaireDocumentTabController",
    template: require("./documents.html"),
    invalidable: true
  });
});
ngModule.controller('InventaireDocumentTabController', function ($rootScope, $scope, $q, $http, $fileDownload, $session, $modal, lovService, $dialogBox, $translate, UUID, documentDrop, $location, documentPreview, fileUtils, $notifications, $authz, $filter, sortUtils) {
  var hasRoleSaisie = $authz.hasRole('SAISIE');
  $http.get('/rest/modeles-documents/list').then(function (response) {
    // pour savoir si il y a des modeles de documents (et afficher le répertoire que si non vide)
    $scope.modelDocuments = response.data;
  });
  $scope.showFileDropOverlay = function () {
    return hasRoleSaisie && documentDrop.isActive() && $scope.docUploadAllowedIn($scope.location.node);
  };
  $scope.$watch(function () {
    return documentDrop.isActive();
  }, function (active) {
    $scope.fileDropActive = active;
  });
  var forcePageQuit = false;
  $scope.loaded = false;
  var display = {
    mode: "vignette",
    // ou "table", ou "maj"
    recursive: false,
    filter: {
      name: null,
      type: null
    }
  };
  $scope.display = display;
  var displayRecursiveSav = false;
  $scope.$watch("display.mode", function (newMode, oldMode) {
    if (oldMode === 'table') {
      displayRecursiveSav = display.recursive;
      display.recursive = false;
    } else if (newMode === 'table') {
      display.recursive = displayRecursiveSav;
    }
    refreshLocationSubNodes();
  });
  $scope.$watch("display.recursive", function () {
    refreshLocationSubNodes();
  });
  $scope.$watch("display.filter", function () {
    refreshLocationSubNodes();
  }, true);
  var baseUrl = '/rest/documents';
  $scope.compteId = $session.getCompte().id;
  $q.when(lovService.getTypesDocuments()).then(function (typesDocument) {
    $scope.typesDocument = typesDocument;
  });

  // Base de connaissance des noeuds de l'arborescence, au format ArborescenceNodeDTO :
  // id, parentId, type, label, subNodesIds, fileId, creationDate, creationUser, le témoin predefined, les stats (nb de docs, de reps, taille, en propre et récursif)
  var nodes = {};

  // Données d'affichage pour la position courante dans l'arborescence
  var location = $scope.location = {
    node: {},
    // Noeud courant
    subNodes: [],
    // Liste des sous noeuds du noeud courant, récursivement si display.recursive = true
    majNodes: [],
    // Liste des documents de tous les sous noeuds du noeud courant, récursivement, pour maj
    arianeNodes: [],
    // Liste ordonnée des noeuds du fil d'ariane (de la racine au noeud courant)
    allowedTypes: [] // Types de docs créables dans le noeud courant
  };
  $scope.location = location;
  $scope.uploadOptions = {
    url: '/rest/documents/upload',
    dropZone: '.page-inventaire-documents',
    formData: {}
  };
  $scope.filterAllowedTypes = function () {
    var allowedTypes;
    if (display.recursive) {
      var subNodes = _computeNodeSubNodes(location.node, display.recursive);
      var subNodesTypes = _.uniq(_.map(subNodes, 'type'));
      allowedTypes = _.filter($scope.typesDocument, function (e) {
        return _.includes(subNodesTypes, e.id);
      });
    } else {
      allowedTypes = location.allowedTypes;
    }
    return allowedTypes;
  };
  var refreshLocationAllowedTypes = function refreshLocationAllowedTypes() {
    location.allowedTypes = _.filter($scope.typesDocument, function (e) {
      return _.includes(location.node.allowedContent, e.id);
    });
    location.allowedTypes.push({
      id: "DIRECTORY",
      label: "Répertoire"
    });
  };
  var updateUploadOptions = function updateUploadOptions(currentNodeId) {
    $scope.uploadOptions.formData.parentNodeId = currentNodeId;
  };
  var getPath = function getPath(node, startNode) {
    var pathNodes = [];
    while (node) {
      if (startNode && node && node.id === startNode.id) {
        break;
      }
      pathNodes.push(node);
      node = nodes[node.parentId];
    }
    return pathNodes.reverse();
  };

  // Reconstruit le fil d'ariane
  var refreshLocationArianeEntries = function refreshLocationArianeEntries() {
    if ($scope.documentContext) {
      var parentId = nodes[$scope.documentContext.root].parentId;
      location.arianeNodes = getPath(location.node, {
        id: parentId
      });
    } else {
      location.arianeNodes = getPath(location.node);
    }
  };
  var _computeNodeSubNodes = function computeNodeSubNodes(node, recursive) {
    var recursiveSubNodes = [];
    if (node.subNodesIds) {
      for (var j = 0; j < node.subNodesIds.length; j++) {
        var subNode = nodes[node.subNodesIds[j]];
        if (subNode != null) {
          if (subNode.type === 'DIRECTORY') {
            recursiveSubNodes.push(subNode);
            if (recursive) {
              recursiveSubNodes.push.apply(recursiveSubNodes, _toConsumableArray(_computeNodeSubNodes(subNode, true)));
            }
          } else {
            recursiveSubNodes.push(subNode);
          }
        }
      }
    }
    return recursiveSubNodes;
  };
  var refreshLocationSubNodes = function refreshLocationSubNodes() {
    var newSubNodes = _computeNodeSubNodes(location.node, display.recursive);
    newSubNodes = _.filter(newSubNodes, function (node) {
      var kept = true;
      if ($scope.display.filter.name) {
        kept = node.label.toLowerCase().includes($scope.display.filter.name.trim().toLowerCase());
      }
      if ($scope.display.filter.type) {
        kept = kept && node.type === $scope.display.filter.type;
      }
      return kept;
    });
    location.subNodes = newSubNodes.map(function (node) {
      return _objectSpread({}, node, {
        tags: node.tags ? _objectSpread({}, node.tags) : null
      });
    });
    _.forEach(location.subNodes, function (node) {
      var chemin = getPath(node, location.node);
      node.completePathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
      chemin.pop(); // Supprimer le nom du fichier lui-même pour ne garder que son chemin
      node.pathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
    });
    location.subNodes.sort(sortUtils.alphanumCompartorBuilder('completePathlabel'));
    buildDocumentsTableOptions();
  };
  var doNavigateTo = $scope.navigateTo = function (nodeId) {
    location.node = nodes[nodeId];
    refreshLocationArianeEntries();
    refreshLocationSubNodes();
    refreshLocationAllowedTypes();
    updateUploadOptions(nodeId);
    if ($scope.display.mode == 'maj') {
      computeMajData();
    }
  };
  var navigateTo = $scope.navigateTo = function (nodeId) {
    var showDialog = $scope.display.mode == 'maj' && $scope.hasDirty();
    if (showDialog) {
      event.preventDefault();
      $dialogBox.confirm({
        title: "Mises à jour non sauvegardées",
        text: "La page comporte des mises à jour non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
      }).then(function () {
        doNavigateTo(nodeId);
      });
    } else {
      doNavigateTo(nodeId);
    }
  };
  $http.get('/rest/documents/arborescence').then(function (response) {
    nodes = response.data.nodes;
    if ($scope.documentContext) {
      navigateTo($scope.documentContext.root);
    } else {
      navigateTo(response.data.defaultNodeId);
    }
    $scope.loaded = true;
  });
  $scope.downloadDocument = function (document) {
    $fileDownload.start('/rest/documents/download/' + document.id);
  };
  var zipDownloadPopinOptions = {
    controller: "zipDownloadPopinController",
    template: require("./zipDownloadPopin.html"),
    options: {
      width: 800
    }
  };
  $scope.downloadZIP = function () {
    var node = nodes[location.node.id];
    var parentNode = nodes[location.node.parentId];
    return $modal.open(_.extend(zipDownloadPopinOptions, {
      scope: $scope,
      vars: {
        nodeId: node.id,
        nbDocs: node.nbDocs,
        nbDocsRec: node.nbDocsRec,
        size: node.size,
        sizeRec: node.sizeRec
      }
    }));
  };
  var editionPopinOptions = {
    controller: "documentEditionPopinController",
    template: require("./documentEditionPopin.html"),
    options: {
      width: 600
    }
  };
  var openEditionPopin = function openEditionPopin(document, initial, allowedContent) {
    var popinOptionsCopy = angular.copy(editionPopinOptions);
    return $modal.open(_.extend(popinOptionsCopy, {
      scope: $scope,
      vars: {
        document: document,
        produitId: location.arianeNodes[location.arianeNodes.length - 1].id,
        initial: initial,
        allowedTypes: _.filter($scope.typesDocument, function (e) {
          return _.includes(allowedContent, e.id);
        })
      }
    }));
  };
  var removeDocFromDirectory = function removeDocFromDirectory(node, directoryId) {
    var parentNode = nodes[directoryId];
    parentNode.subNodesIds = _.without(parentNode.subNodesIds, node.id);
    parentNode.nbDocs -= node.nbDocs;
    parentNode.nbReps -= node.nbReps;

    // par convention, le size d'un dossier est la somme des tailles des fichiers qu'il contient'
    parentNode.size -= node.size;

    // Mise à jour des stats
    while (parentNode != null) {
      parentNode.nbDocsRec -= node.nbDocsRec;
      parentNode.nbRepsRec -= node.nbRepsRec;
      parentNode.sizeRec -= node.sizeRec;
      parentNode = nodes[parentNode.parentId];
    }
  };
  var addDocToDirectory = function addDocToDirectory(node, directoryId) {
    var parentNode = nodes[directoryId];
    var currentNode = nodes[node.id];
    parentNode.subNodesIds.push(node.id);
    currentNode.parentId = directoryId;
    currentNode.rootId = findRootIdForChildOf(directoryId);
    if (!currentNode.creationDate) {
      currentNode.creationDate = moment();
    }
    if (!currentNode.creationUser) {
      currentNode.creationUser = $session.getUser().denomination;
    }
    parentNode.nbDocs += node.nbDocs;
    parentNode.nbReps += node.nbReps;

    // par convention, le size d'un dossier est la somme des tailles des fichiers qu'il contient'
    parentNode.size += node.size;

    // Mise à jour des stats
    while (parentNode != null) {
      parentNode.nbDocsRec += node.nbDocsRec;
      parentNode.nbRepsRec += node.nbRepsRec;
      parentNode.sizeRec += node.sizeRec;
      parentNode = nodes[parentNode.parentId];
    }
  };
  $scope.docUploadAllowedIn = function (node) {
    var allowedContent = node.allowedContent;
    var length = allowedContent ? allowedContent.length : 0;
    return length > _.includes(allowedContent, "DIRECTORY") ? 1 : 0;
  };
  $scope.externalDocAllowedIn = function (node) {
    return $authz.hasRole('DOCUMENTS_EXTERNES') && $scope.docUploadAllowedIn(node);
  };
  $scope.directoryCreationAllowedIn = function (node) {
    return _.includes(node.allowedContent, "DIRECTORY");
  };
  $scope.lastType = null;
  $scope.lastParentId = null;
  var uploadSequence = $q.when();
  var uploadCancelled = false;
  var pendingUploads = 0;
  $scope.nbUpload = 0;
  $scope.nbFinishedUpload = 0;
  $scope.beforeDocumentUpload = function (uploadOptions, addedFile) {
    if (pendingUploads === 0) {
      uploadCancelled = false;
    }
    pendingUploads++;
    $scope.nbUpload++;
    var nextStep = uploadSequence.then(function () {
      if (uploadCancelled) {
        return $q.reject('cancelled');
      }
      var document = {
        type: $scope.lastType,
        label: addedFile.name || $translate('documents.NouveauDocument'),
        // repertoire
        parentId: $scope.lastParentId,
        relativePath: addedFile.relativePath
      };
      return openEditionPopin(document, true, location.node.allowedContent).then(function (documentInfos) {
        if (!documentInfos) {
          return $q.reject('cancelled');
        }
        // on conserve le type choisi pour le reprooposer par defaut sur la prochaine fenetre.
        $scope.lastType = documentInfos.type;
        $scope.lastParentId = documentInfos.parentId;
        return _objectSpread({}, uploadOptions.formData, {}, documentInfos, {}, documentInfos.tags);
      }).catch(function (err) {
        console.log('reject !', err);
        uploadCancelled = true;
        return $q.reject(err);
      });
    });
    uploadSequence = nextStep.catch(function () {});
    return nextStep.finally(function () {
      pendingUploads--;
      $scope.nbFinishedUpload++;
      console.log('pendingUploads', pendingUploads);
      if (pendingUploads === 0) {
        $scope.lastType = null;
        $scope.lastParentId = null;
        $scope.nbUpload = 0;
        $scope.nbFinishedUpload = 0;
      }
    });
  };
  $scope.onDocumentUpload = function (result, config) {
    var rootId = findRootIdForChildOf(result.parentNodeId);
    var document = {
      id: result.documentId,
      type: result.type,
      label: result.fileName,
      fileId: result.fileId,
      rootId: rootId,
      nbDocs: 1,
      nbDocsRec: 1,
      nbReps: 0,
      nbRepsRec: 0,
      tags: result.tags,
      size: result.fileSize,
      sizeRec: result.fileSize,
      relativePath: config.files[0].relativePath
    };
    nodes[document.id] = document;
    addDocToDirectory(document, result.parentNodeId);
    refreshLocationSubNodes();
  };
  var isPretOuDetteDirectory = function isPretOuDetteDirectory(node) {
    return node.id.startsWith("DETTE@") || node.id.startsWith("PRET@");
  };
  var computeMajData = function computeMajData() {
    var recursiveSubNodes = _computeNodeSubNodes(location.node, true);
    recursiveSubNodes = _.filter(recursiveSubNodes, function (node) {
      return node.type !== 'DIRECTORY';
    });
    location.majNodes = recursiveSubNodes.map(function (node) {
      return _objectSpread({}, node, {
        tags: node.tags ? _objectSpread({}, node.tags) : null
      });
    });
    _.forEach(location.majNodes, function (node) {
      var chemin = getPath(node, location.node);
      node.completePathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
      chemin.pop(); // Supprimer le node du fichier lui-même pour ne garder que son chemin
      node.pathlabel = _.map(chemin, function (path) {
        return path ? path.label : "";
      }).join(' > ');
      var paths = getPath(node);
      node.docDetteOuPret = _.some(paths, isPretOuDetteDirectory);
    });
    location.majNodes.sort(sortUtils.alphanumCompartorBuilder('completePathlabel'));
  };
  $scope.isDirty = function (majNode) {
    var node = nodes[majNode.id];
    var nodeNonJustificatif = node.tags == null || node.tags == [] || node.tags.JUSTIFICATIF_TRESORERIE == false;
    var majNodeNonJustificatif = majNode.tags == null || majNode.tags == [] || majNode.tags.JUSTIFICATIF_TRESORERIE == false;
    return nodeNonJustificatif !== majNodeNonJustificatif;
  };
  $scope.hasDirty = function () {
    var dirty = _.some(location.majNodes, $scope.isDirty);
    return dirty;
  };
  $scope.changeDisplayMode = function (mode) {
    if (mode == 'maj') {
      computeMajData();
      $scope.display.mode = mode;
    } else {
      var showDialog = $scope.display.mode == 'maj' && $scope.hasDirty();
      if (showDialog) {
        event.preventDefault();
        $dialogBox.confirm({
          title: "Mises à jour non sauvegardées",
          text: "La page comporte des mises à jour non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
        }).then(function () {
          $scope.display.mode = mode;
        });
      } else {
        $scope.display.mode = mode;
      }
    }
  };
  $rootScope.$on("$locationChangeStart", function (event, next, current) {
    var showDialog = !forcePageQuit && $scope.display.mode == 'maj' && $scope.hasDirty();
    if (showDialog) {
      event.preventDefault();
      $dialogBox.confirm({
        title: "Mises à jour non sauvegardées",
        text: "La page comporte des mises à jour non sauvegardées. Si vous quittez maintenant, " + "toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?"
      }).then(function () {
        forcePageQuit = true;
        $location.$$parse(next);
      });
    }
  });
  $scope.saveMaj = function () {
    var majs = [];
    _.forEach(location.majNodes, function (document) {
      if ($scope.isDirty(document)) {
        majs.push({
          id: document.id,
          label: document.label,
          type: document.type,
          url: document.url,
          tags: document.tags
        });
      }
    });
    $http.post(baseUrl + "/updates", majs).finally(function () {
      _.forEach(location.majNodes, function (document) {
        if ($scope.isDirty(document)) {
          nodes[document.id].tags = document.tags == null ? null : _objectSpread({}, document.tags);
        }
      });
    });
  };
  $scope.editDocument = function (document) {
    openEditionPopin(document, false, location.node.allowedContent).then(function () {
      $http.post(baseUrl + "/update", {
        id: document.id,
        label: document.label,
        type: document.type,
        url: document.url,
        tags: document.tags
      }).finally(function () {
        nodes[document.id] = document;
        refreshLocationSubNodes();
      });
    });
  };
  $scope.removeDocument = function (document) {
    $dialogBox.confirm({
      title: $translate("common.confirm_delete"),
      text: $translate("saisie.documents.popins.delete.text", {
        filename: document.label
      })
    }).then(function () {
      $http.post(baseUrl + "/delete", document.id).then(function () {
        removeDocFromDirectory(document, document.parentId);
        delete nodes[document.id];
        if ($scope.previewedDoc && $scope.previewedDoc.id == document.id) {
          $scope.previewedDoc = null;
        }
        $notifications.info('Document \'' + document.label + '\' supprimé.');
      }).finally(function () {
        refreshLocationSubNodes();
      });
    });
  };
  $scope.createDocumentExterne = function () {
    var document = {
      id: UUID(),
      type: null,
      label: "",
      url: "",
      nbDocs: 1,
      nbDocsRec: 1,
      nbReps: 0,
      nbRepsRec: 0,
      size: 0,
      sizeRec: 0
    };
    var parentNodeId = location.arianeNodes[location.arianeNodes.length - 1].id;
    openEditionPopin(document, true, location.node.allowedContent).then(function () {
      $http.post(baseUrl + "/add", document, {
        params: {
          parentNodeId: parentNodeId
        }
      }).then(function () {
        nodes[document.id] = document;
        addDocToDirectory(document, parentNodeId);
      }).finally(function () {
        refreshLocationSubNodes();
      });
    });
  };
  var directoryEditionPopinOptions = {
    controller: "directoryEditionPopinController",
    template: require("./directoryEditionPopin.html"),
    options: {
      width: 600
    }
  };
  var openDirectoryEditionPopin = function openDirectoryEditionPopin(document, initial) {
    return $modal.open(_.extend(directoryEditionPopinOptions, {
      scope: $scope,
      vars: {
        document: document,
        initial: initial
      }
    }));
  };
  function estUnRootId(nodeId) {
    var some = _.some(nodes, function (node) {
      return node.rootId === nodeId;
    });
    return some;
  }
  function findRootIdForChildOf(nodeId) {
    var rootId = null;
    var parentId = nodeId;
    var lastParentId = parentId;
    while (rootId == null && parentId != null) {
      if (estUnRootId(parentId)) {
        rootId = parentId;
      } else {
        lastParentId = parentId;
        parentId = nodes[parentId].parentId;
      }
    }
    if (rootId == null) {
      rootId = lastParentId;
    }
    //console.log("Root trouvé : " + nodes[rootId].label + " pour " + nodes[nodeId].label);
    return rootId;
  }
  $scope.createDirectory = function () {
    var parentNodeId = location.arianeNodes[location.arianeNodes.length - 1].id;
    var rootId = findRootIdForChildOf(parentNodeId);
    var document = {
      id: UUID(),
      type: "DIRECTORY",
      nbDocs: 0,
      nbDocsRec: 0,
      nbReps: 1,
      nbRepsRec: 1,
      size: 0,
      sizeRec: 0,
      subNodesIds: [],
      allowedContent: nodes[parentNodeId].allowedContent,
      rootId: rootId
    };
    openDirectoryEditionPopin(document, true).then(function () {
      $scope.loading = true;
      $http.post(baseUrl + "/add", document, {
        params: {
          parentNodeId: parentNodeId
        }
      }).then(function () {
        nodes[document.id] = document;
        addDocToDirectory(document, parentNodeId);
      }).finally(function () {
        refreshLocationSubNodes();
        $scope.loading = false;
      });
    });
  };
  $scope.editDirectory = function (document) {
    openDirectoryEditionPopin(document, false).then(function () {
      $scope.loading = true;
      $http.post(baseUrl + "/update", {
        id: document.id,
        label: document.label
      }).then(function () {
        refreshLocationSubNodes();
      });
    }).finally(function () {
      $scope.loading = false;
    });
  };
  $scope.removeDirectory = function (document) {
    $dialogBox.confirm({
      title: $translate("common.confirm_delete"),
      text: $translate("saisie.documents.popins.delete.text", {
        filename: document.label
      })
    }).then(function () {
      $http.post(baseUrl + "/delete", document.id).then(function () {
        removeDocFromDirectory(document, document.parentId);
        delete nodes[document.id];
        refreshLocationSubNodes();
      });
    });
  };
  var moveNodePopinOptions = {
    controller: "moveNodePopinController",
    template: require("./moveNodePopin.html"),
    options: {
      width: 800
    }
  };
  var openMoveNodePopin = function openMoveNodePopin(document) {
    return $modal.open(_.extend(moveNodePopinOptions, {
      scope: $scope,
      vars: {
        document: document
      }
    }));
  };
  var getNodeCompletePathLabel = function getNodeCompletePathLabel(node) {
    var completePath = node.label;
    var parentId = node.parentId;
    while (parentId != null) {
      var parentNode = nodes[parentId];
      completePath = parentNode.label + " -> " + completePath;
      parentId = parentNode.parentId;
    }
    return completePath;
  };
  var aPourParent = function aPourParent(node, possibleParentId) {
    var parentId = node.parentId;
    while (parentId != null) {
      if (parentId === possibleParentId) {
        return true;
      }
      parentId = nodes[parentId].parentId;
    }
  };
  $scope.moveNode = function (node) {
    var previousParentId = node.parentId;
    $scope.directories = _.map(_.filter(nodes, function (n) {
      return n.type === 'DIRECTORY' && n.id !== node.id // Pas le noeud qu'on essaie de bouger
      && n.id !== node.parentId // pas le parent actuel du noeud qu'on essaie de bouger
      && !aPourParent(n, node.id) // Pas un enfant du noeud qu'on essaie de bouger
      // Avec le même rootId ou bien dont l'id est le rootId du noeud qu'on essaie de bouger
      && (node.rootId === undefined || node.rootId === null || n.rootId === node.rootId || n.id === node.rootId);
    }), function (d) {
      return {
        id: d.id,
        label: getNodeCompletePathLabel(d)
      };
    });
    openMoveNodePopin(node).then(function () {
      if (node.parentId === '__NEW_DIR') {
        var parentNodeId = location.arianeNodes[location.arianeNodes.length - 1].id;
        var rootId = findRootIdForChildOf(parentNodeId);
        var document = {
          id: UUID(),
          type: "DIRECTORY",
          nbDocs: 0,
          nbDocsRec: 0,
          nbReps: 1,
          nbRepsRec: 1,
          size: 0,
          sizeRec: 0,
          subNodesIds: [],
          allowedContent: nodes[rootId].allowedContent,
          rootId: rootId
        };
        openDirectoryEditionPopin(document, true).then(function () {
          $scope.loading = true;
          $http.post(baseUrl + "/add", document, {
            params: {
              parentNodeId: parentNodeId
            }
          }).then(function () {
            nodes[document.id] = document;
            addDocToDirectory(document, parentNodeId);
          }).then(function () {
            node.parentId = document.id;
            removeDocFromDirectory(node, previousParentId);
            addDocToDirectory(node, node.parentId);
          }).finally(function () {
            refreshLocationSubNodes();
            $scope.loading = false;
          });
        });
      } else {
        $scope.loading = true;
        $http.post(baseUrl + "/move", node.id, {
          params: {
            newParentNodeId: node.parentId
          }
        }).then(function () {
          removeDocFromDirectory(node, previousParentId);
          addDocToDirectory(node, node.parentId);
        }).finally(function () {
          refreshLocationSubNodes();
          $scope.loading = false;
        });
      }
    });
  };
  $scope.renderType = function (document) {
    if (document.tags && document.tags.DATE_ECHEANCE) {
      return $translate("lov.typesDocuments." + document.type) + " " + $translate('lov.typesDocuments.DU', {
        'date': $filter("dateShort")(document.tags.DATE_ECHEANCE)
      });
    }
    return $translate("lov.typesDocuments." + document.type);
  };
  $scope.getDocumentIcon = function (document) {
    var ext = document.fileId == null ? null : fileUtils.getExtension(document.fileId);
    return fileUtils.getExtensionIcon(ext);
  };
  var buildDocumentsTableOptions = function buildDocumentsTableOptions() {
    $scope.documentsTableOptions = {
      source: "location.subNodes",
      sortable: true,
      initialSort: [0, "asc"],
      columns: [{
        attribute: 'completePathlabel',
        title: $translate("documents.Nom"),
        sortType: "alphanum",
        template: "\n                    <span ng-if=\"::model.type == 'DIRECTORY' \">\n                        <span ng-click=\"navigateTo(model.id)\" class=\"folder-link\">\n                            <i class=\"fa fa-folder-o\"></i>\n                            <span>{{::model.pathlabel}}{{::model.pathlabel?' > ':''}}{{::model.label}}</span>\n                        </span>\n                    </span>\n                    <span ng-if=\"::model.type != 'DIRECTORY' \">\n<!--                        <i class=\"{{::getDocumentIcon(model)}}\"></i>-->\n                        <span>{{::model.pathlabel}}{{::model.pathlabel?' > ':''}}<span style=\"font-weight:bold\">{{::model.label}}</span></span>\n                    </span>",
        sortable: true
      }, {
        attribute: 'type',
        title: $translate("documents.Type"),
        filter: "translateLov:'typesDocuments'",
        width: 100,
        template: '<span>{{renderType(model)}}</span>',
        sortType: "string",
        sortable: true
      }, {
        attribute: 'sizeRec',
        title: $translate("documents.Taille"),
        width: 100,
        filter: "bytes",
        sortType: "number",
        template: '<span>{{model.type === "DIRECTORY" ? (model.sizeRec > 0 ? (model.sizeRec | bytes) : "") : model.fileId ? (model.size | bytes) : ("documents.DocumentExterne" |translate) }}</span>',
        sortable: true
      }, {
        attribute: 'creationDate',
        title: $translate("documents.DateDAjout"),
        width: 100,
        cellClass: "align-c",
        filter: "dateShort",
        sortType: "date",
        sortable: true
      }, {
        attribute: 'creationUser',
        title: $translate("documents.AjoutePar"),
        width: 200,
        template: '<span>{{::model.predefined ? "Prédéfini" : model.creationUser}}</span>',
        sortable: true
      },
      // actions
      {
        attribute: 'actions',
        title: '',
        width: 200,
        template: "\n                <div ng-if=\"model.type == 'DIRECTORY' \" class=\"actions\"> \n                    <tl-icon-button authz-if-role=\"SAISIE\" ng-if=\"!model.predefined\" icon=\"fa-pencil-square-o\" tl-tooltip=\"{{'documents.Editer' | translate}}\" ng-click=\"editDirectory(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" ng-if=\"!model.predefined\" icon=\"fa-arrow-right\" tl-tooltip=\"{{'documents.Deplacer' | translate}}\" ng-click=\"moveNode(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" ng-if=\"!model.predefined && model.nbReps + model.nbDocs == 1\" icon=\"fa-times-circle\" tl-tooltip=\"{{'documents.Supprimer' | translate}}\" ng-click=\"removeDirectory(model)\"></tl-icon-button> \n                </div> \n                <div ng-if=\"model.type != 'DIRECTORY' \" class=\"actions\"> \n                    <tl-icon-button icon=\"fa-eye\" tl-tooltip=\"{{'documents.Previsualiser' | translate}}\" ng-if=\"canPreview(model)\" ng-click=\"previewDocument(model)\"></tl-icon-button> \n                    <tl-icon-button icon=\"fa-download\" tl-tooltip=\"{{'documents.Telecharger' | translate}}\" ng-click=\"downloadDocument(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" icon=\"fa-pencil-square-o\" tl-tooltip=\"{{'documents.Editer' | translate}}\" ng-click=\"editDocument(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" icon=\"fa-arrow-right\" tl-tooltip=\"{{'documents.Deplacer' | translate}}\" ng-click=\"moveNode(model)\"></tl-icon-button> \n                    <tl-icon-button authz-if-role=\"SAISIE\" icon=\"fa-times-circle\" tl-tooltip=\"{{'documents.Supprimer' | translate}}\" ng-click=\"removeDocument(model)\"></tl-icon-button> \n                </div>",
        cellClass: 'align-c',
        sortable: false
      }]
    };
  };
  $scope.documentsMajTableOptions = {
    source: "location.majNodes",
    columns: [{
      attribute: 'completePathlabel',
      title: $translate("documents.Nom"),
      template: "\n                    <span>\n                        <i ng-if=\"isDirty(model)\" tl-tooltip=\"Modifi\xE9\" class=\"mr-s fa allowed green fa-check-square-o\" ></i>\n                        <i class=\"{{::getDocumentIcon(model)}}\"></i>\n                        <span>{{::model.pathlabel}}{{::model.pathlabel?' > ':''}}<span style=\"font-weight:bold\">{{::model.label}}</span></span>\n                    </span>",
      sortable: true
    }, {
      attribute: 'type',
      title: $translate("documents.Type"),
      filter: "translateLov:'typesDocuments'",
      template: '<span>{{renderType(model)}}</span>',
      width: 100,
      sortType: "string",
      sortable: true
    }, {
      attribute: 'size',
      title: $translate("documents.Taille"),
      width: 100,
      filter: "bytes",
      cellClass: "align-r",
      sortType: "number",
      template: '<span>{{model.fileId ? (model.size | bytes) : ("documents.DocumentExterne" |translate) }}</span>',
      sortable: true
    }, {
      attribute: 'creationDate',
      title: $translate("documents.DateDAjout"),
      width: 100,
      cellClass: "align-c",
      filter: "dateShort",
      sortType: "date",
      sortable: true
    }, {
      attribute: 'creationUser',
      title: $translate("documents.AjoutePar"),
      width: 200,
      template: '<span>{{::model.predefined ? "Prédéfini" : model.creationUser}}</span>',
      sortable: true
    }, {
      attribute: 'tags',
      width: 100,
      cellClass: "align-c",
      title: $translate("documents.JustificatifComptable"),
      template: '<tl-checkbox ng-if="model.docDetteOuPret" ng-model="model.tags.JUSTIFICATIF_TRESORERIE"/>'
    }]
  };
  $scope.previewDocument = function (document) {
    $scope.previewedDoc = document;
  };
  $scope.closePreview = function () {
    $scope.previewedDoc = null;
  };
  $scope.canPreview = function (document) {
    return documentPreview.canPreview(document);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/inventaire/documents/documents.js
// module id = 2827
// module chunks = 13